import type { IconProps } from './types';
import './icons.css';

export default function Pdf({
  width,
  height,
  className = '',
}: IconProps): React.JSX.Element {
  return (
    <svg
      width={width || 24}
      height={height || 24}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      className={`icon icon-pdf ${className || ''}`}
      fill="none"
    >
      <path
        stroke="currentColor"
        d="M5 10V4c0-.551.449-1 1-1h8.586L19 7.414V20c0 .551-.449 1-1 1H6c-.551 0-1-.449-1-1v-3"
      />
      <path
        fill="currentColor"
        d="M18.5 8H15a1 1 0 0 1-1-1V3.5L18.5 8Zm-13 4H5v1h.5a.5.5 0 0 0 0-1Zm4.128.023H9V15h.615c.632 0 1.385-.191 1.385-1.099v-.772c0-.914-.746-1.106-1.372-1.106Z"
      />
      <path
        fill="currentColor"
        d="M4 9a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h15V9H4Zm1.5 5H5v2H4v-5h1.5a1.5 1.5 0 0 1 0 3Zm6.5-.099C12 15.069 11.209 16 9.615 16H8v-4.977h1.628c1.582 0 2.372.952 2.372 2.106v.772ZM16 12h-2v1h1.6v1H14v2h-1v-5h3v1Z"
      />
    </svg>
  );
}
